import { render, staticRenderFns } from "./index6.vue?vue&type=template&id=81d89884&scoped=true"
import script from "./index6.vue?vue&type=script&lang=js"
export * from "./index6.vue?vue&type=script&lang=js"
import style0 from "./index6.vue?vue&type=style&index=0&id=81d89884&prod&lang=scss"
import style1 from "./index6.vue?vue&type=style&index=1&id=81d89884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d89884",
  null
  
)

export default component.exports